import { render, staticRenderFns } from "./SecondaryUserTerms.vue?vue&type=template&id=7cb4905d&scoped=true"
import script from "./SecondaryUserTerms.vue?vue&type=script&lang=js"
export * from "./SecondaryUserTerms.vue?vue&type=script&lang=js"
import style0 from "./SecondaryUserTerms.vue?vue&type=style&index=0&id=7cb4905d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb4905d",
  null
  
)

export default component.exports